import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import store from './store/store';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';

import Scaffold from './page/Scaffold';

import PageHome from './page/Home/PageHome';
import PageFAQ from './page/FAQ';
import PageRisingStar from './page/PageRisingStar';
import PageNotification from './page/Notif';
import PageMessaging from './page/Messaging';
import PageTalentPool from './page/TalentPool';
import PageSearch from './page/Search';
import PageOfficialAccount from './page/OfficialAccount';

import PageProfile from './page/Profile';
import PageProfileBio from './page/Profile/Bio';
import PageProfileInitiative from './page/Profile/Initiative';
import PageProfileSkill from './page/Profile/Skill';
import PageProfileInterest from './page/Profile/Interest';
import PageProfileRating from './page/Profile/Rating';
import PageProfileEdit from './page/Profile/Edit';

import PageProfileUser from './page/Profile/User';
import PageProfileUserBio from './page/Profile/User/Bio';
import PageProfileUserActivity from './page/Profile/User/Activity';
import PageProfileUserSkill from './page/Profile/User/Skill';
import PageProfileConfig from './page/Profile/Configuration';

import PageRegistrationBasicInfo from './page/Registration/PageRegistrationBasicInfo';
import PageRegistrationInterest from './page/Registration/PageRegistrationInterest';
import PageRegistrationGetStarted from './page/Registration/PageRegistrationGetStarted';

import PageBrowseInitiative from './page/Initiative/Browse/';
import PageHomeResearch from './page/Initiative/BrandType/Research';
import PageBrowseResearch from './page/Initiative/BrandType/Research/Archive';
import PageHomeEvent from './page/Initiative/BrandType/Event';
import PageHomeEventCrew from './page/Initiative/BrandType/Event/Crew';
import PageBrowseEvent from './page/Initiative/BrandType/Event/Archive';
import PageHomeTalent from './page/Initiative/BrandType/Talent';
import PageBrowseTalent from './page/Initiative/BrandType/Talent/Archive';

import PageInsideInitiative from './page/Initiative/Inside/Scaffold';
import PageInsideInitiativeAbout from 'page/Initiative/Inside/About';
import PageInsideInitiativeMember from 'page/Initiative/Inside/Member';
import PageInsideInitiativeTalk from 'page/Initiative/Inside/Talk';
import PageInsideInitiativeUpdates from 'page/Initiative/Inside/Updates';
import PageInsideInitiativeRating from 'page/Initiative/Inside/Rating';
import PageInsideInitiativeSAT from 'page/Initiative/Inside/SAT';
import PageInsideInitiativeSurvey from 'page/Initiative/Inside/Survey';
import PageInsideInitiativeResponseSurvey from 'page/Initiative/Inside/Survey/Response';

import PageCreateAgreementInitiative from './page/Initiative/Create/Agreement'
import PageCreateInitiative from './page/Initiative/Create/ChooseType';
import PageCreateFormInitiative from './page/Initiative/Create/BasicForm';
import PageCreateFormEvent from './page/Initiative/Create/Event';
import PageCreateFormResearch from './page/Initiative/Create/Research';

import PagePagesCreate from './page/Pages/Create';
import PagePagesInside from './page/Pages/Inside';
import PagePagesBrowse from './page/Pages/Browse';

import PageMonitorSA from './page/Monitor/SA';
import PageMonitorRTT from './page/Monitor/RTT';
import PagePrezi from './page/prezi';

const container = document.getElementById('root');
const root = createRoot(container);
if (process.env.NODE_ENV === 'production') 
{
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}
root.render(
    <Provider store={store}>
      <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
        <Routes>
          <Route path="/" element={<PageHome/>}/>
          <Route path="/faq" element={<PageFAQ/>}/>
          <Route path="/rising-star" element={<PageRisingStar/>}/>
          <Route path="/notification" element={<PageNotification/>}/>
          <Route path="/messaging" element={<PageMessaging/>}/>
          <Route path="/talent-pool" element={<PageTalentPool/>}/>
          <Route path="/official" element={<PageOfficialAccount/>}/>
          <Route path="/search" element={<PageSearch/>}/>
          <Route path="/profile" element={<PageProfile/>}>
              <Route path="" element={<PageProfileBio/>}/>
              <Route path="interest" element={<PageProfileInterest/>}/>
              <Route path="initiative" element={<PageProfileInitiative/>}/>
              <Route path="skill" element={<PageProfileSkill/>}/>
              <Route path="rating" element={<PageProfileRating/>}/>
              <Route path="configuration" element={<PageProfileConfig/>}/>
              <Route path="update" element={<PageProfileEdit/>}/>
          </Route>

          <Route path="/user/:user_name" element={<PageProfileUser/>}>
            <Route path="" element={<PageProfileUserBio/>}/>
            <Route path="activity" element={<PageProfileUserActivity/>}/>
            <Route path="skill" element={<PageProfileUserSkill/>}/>
          </Route>

          <Route path="/group" >
            <Route path="" element={<PagePagesBrowse is_official={0}/>}/>
            <Route path="create" element={<PagePagesCreate/>}/>
            <Route path=":page_slug" element={<PagePagesInside/>}/>
          </Route>

          <Route path="/page" element={<PagePagesBrowse is_official={1}/>} />
          <Route path="/prezi" element={<PagePrezi/>} />

          <Route path="/research" >
            <Route path="" element={<PageHomeResearch/>}/>
            <Route path="browse" element={<PageBrowseResearch/>}/>
          </Route>

          <Route path="/event" >
            <Route path="" element={<PageHomeEvent/>}/>
            <Route path="crew" element={<PageHomeEventCrew/>}/>
            <Route path="browse" element={<PageBrowseEvent/>}/>
          </Route>

          <Route path="/talent" >
            <Route path="" element={<PageHomeTalent/>}/>
            <Route path="browse" element={<PageBrowseTalent/>}/>
          </Route>

          <Route path="/initiative" element={<Scaffold/>}>
            <Route path="" element={<PageBrowseInitiative/>}/>
            <Route path=":initiative_slug" element={<PageInsideInitiative/>}>
              <Route path="" element={<PageInsideInitiativeAbout/>}/>
              <Route path="member" element={<PageInsideInitiativeMember/>}/>
              <Route path="discussion" element={<PageInsideInitiativeTalk/>}/>
              <Route path="updates" element={<PageInsideInitiativeUpdates/>}/>
              <Route path="rating" element={<PageInsideInitiativeRating/>}/>
              <Route path="sat" element={<PageInsideInitiativeSAT/>}/>
              <Route path="survey" element={<PageInsideInitiativeSurvey/>}/>
              <Route path="response-survey/:survey_id" element={<PageInsideInitiativeResponseSurvey/>}/>
            </Route>
          </Route>
          <Route path="/create" element={<Scaffold/>}>
            <Route path="" element={<PageCreateAgreementInitiative/>}/>
            <Route path="choose" element={<PageCreateInitiative/>}/>
            <Route path="describe" element={<PageCreateFormInitiative/>}/>
            <Route path="event" element={<PageCreateFormEvent/>}/>
            <Route path="research" element={<PageCreateFormResearch/>}/>
          </Route>
          <Route path="/registration" element={<Scaffold/>}>
            <Route path="" element={<PageRegistrationBasicInfo/>} />
            <Route path="declare-interest" element={<PageRegistrationInterest/>} />
            <Route path="get-started" element={<PageRegistrationGetStarted/>} />
          </Route>

          <Route path="/monitor" element={<Scaffold/>} >
            <Route path="sa" element={<PageMonitorSA/>} />
            <Route path="rtt" element={<PageMonitorRTT/>} />
          </Route>

        </Routes>
      </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
